/* globals google */
'use strict';

var baseStore = require('base/storeLocator/storeLocator');
var scrollAnimate = require('base/components/scrollAnimate');

/** Save as your store */
function saveAsMyStore(event) {
	var storeDetails = $(event.target).closest('.card-body').find('.store-details');
	var storeDistance = storeDetails.find('.store-distance').text();
	var storeId = storeDetails.attr('data-store-id');
	var cookieValue = storeId + '-' + storeDistance;
	var storeName = storeDetails.find('.store-name').attr('data-store-name');
	var yourStoreName = 'Your Store';
	var saveAsMyStoreName = 'Save As My Store';

	document.cookie = `myStore=${cookieValue};path=/;SameSite=None;Secure`;

	//GTM Push for  SAVE AS MY STORE
	var gtmData = {};
	gtmData.eventAction = 'Save As My Store';
	gtmData.eventLabel = storeDetails.find('.store-name').data('store-fullname');
	$('body').trigger('storeloc:saveasmystore', gtmData);

	if($(event.target).closest('.cart-page').length > 0 && $(event.target).closest('.cart-page') !== undefined){
		var getModalCloseBtn = $('.cart-page #storeModalDialog .modal-header').find('.close');
		if(getModalCloseBtn.attr('data-store-change') == 'false') {
			getModalCloseBtn.attr('data-store-change', 'true');	
		} else {
			getModalCloseBtn.attr('data-store-change', 'false');	
		}
	}
	
	var getAllStore = $('.store-locator-container .card-body .form-check');
	getAllStore.find('.store-hours-container').addClass('d-none');
	if (getAllStore.length > 0 && getAllStore !== undefined) {
		getAllStore.find('.your-store').removeClass('your-store').addClass('btn-save-store');
		getAllStore.find('.btn-save-store').text(saveAsMyStoreName);
	}

	var getSelectedStore = $(event.target);
	if (getSelectedStore.length > 0 && getSelectedStore !== undefined) {
		getSelectedStore.removeClass('btn-save-store').addClass('your-store');
		getSelectedStore.text(yourStoreName);
	}

	var getHeaderStoreName = $('.navigation .navbar-header .header-right .header-find-store').find('.header-icon-label');
	if (getHeaderStoreName.length > 0 && getHeaderStoreName !== undefined) {
		getHeaderStoreName.text(storeName);
		getHeaderStoreName.attr('title', storeName);
		
		if (window.innerWidth <= 767) {
			$('.header-find-store').find('.link-track').find('.hidden-md-down.header-icon-label.user-message').removeClass('hidden-md-down');
		}
	}
	var getCartStoreName = $('.cart-page .cart-page-right-section .cart-totals-delivery .delivery-pickup-info-section').find('.store-name');
	var getCartStoreNameFindStore = $('.cart-page .cart-page-right-section .cart-totals-delivery .delivery-pickup-info-section').find('.find-a-store');
	if (getCartStoreName.length > 0 && getCartStoreName !== undefined) {
		getCartStoreName.text(storeName);
		getCartStoreNameFindStore.attr('data-store-present', storeName);
	}
	var isProductDetails = $('.product-detail') && $('.product-detail').length > 0 ? true : false;
	var getPDPStoreName = $('.product-detail .product-detail-left-section .delivery-options .shipping-pickup-store .delivery-pickup-info-section').find('.store-name');
	var getPDPStoreNameFindStore = isProductDetails ? $('.product-detail .find-a-store-pdp') :  $('.product-detail .product-detail-left-section .delivery-options .shipping-pickup-store .delivery-pickup-info-section').find('.find-a-store');
	if (getPDPStoreName.length > 0 && getPDPStoreName !== undefined) {
		getPDPStoreName.text(storeName);
		getPDPStoreNameFindStore.attr('data-store-present', storeName);
		var storeLinkLabel = isProductDetails ? $('.product-detail .find-a-store-pdp') : $('.product-detail .product-detail-left-section .delivery-options .shipping-pickup-store .delivery-pickup-info-section').find('.find-a-store');
		storeLinkLabel.text('Change Store');
	}
	getSelectedStore.parents('#storeModalDialog').find('.close').trigger('click');
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
	var newUrl = url;
	newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
		return key + '=' + encodeURIComponent(params[key]);
	}).join('&');

	return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
	var map;
	var infowindow = new google.maps.InfoWindow();
	var wholesaleStoreType = $('.wholesale-store-type').val();
	var googleMapID = $('.google-map-id').val();
	var isFromModal = $('.is-store-from-modal').val();
	var isProductDetails = $('.product-detail') && $('.product-detail').length > 0 ? true : false;
	// Init U.S. Map in the center of the viewport
	var mapOptions = {
		scrollwheel: false,
		zoom: 4,
		center: {lat: 37.09024, lng: -95.712891},
		mapId: googleMapID
	};
	var mapCanvas = isProductDetails ? $('.map-canvas:visible') : $('.map-canvas');
	map = new google.maps.Map(mapCanvas[0], mapOptions);
	var mapdiv = mapCanvas.attr('data-locations');
	var defaultzoom = map.getZoom();
	mapdiv = JSON.parse(mapdiv);

	var bounds = new google.maps.LatLngBounds();

	map.addListener('zoom_changed', () => {
		var gtmData = {};
		gtmData.eventAction = 'Map Interaction';
		if(map.getZoom() <= defaultzoom){
			gtmData.eventLabel = 'Zoom Out';
		}else if(map.getZoom() > defaultzoom){
			gtmData.eventLabel = 'Zoom In';
		}
		defaultzoom = map.getZoom();
		$('body').trigger('storeloc:zoom', gtmData);
	});

	var lableCount = 0;
	Object.keys(mapdiv).forEach(function (key) {
		var item = mapdiv[key];
		const markerImg = document.createElement('div');
		markerImg.className = 'marker-img';
		if(isFromModal){
			if(item.storeType !== wholesaleStoreType && item.storePickup && !item.storeComingSoon) {
				lableCount++;
				let storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
				markerImg.textContent = lableCount.toString();
				let marker = new google.maps.marker.AdvancedMarkerElement({
					position: storeLocation,
					map: map,
					title: item.name,
					content: markerImg,
					gmpClickable: true
				});
		
				marker.addListener('click', function () {
					infowindow.setOptions({
						content: item.infoWindowHtml
					});
					infowindow.open(map, marker);
					//GTM Push for Selected store
					var gtmData = {};
					gtmData.eventAction = 'Map Interaction';
					gtmData.eventLabel = 'Select Store - ' + item.name;
					$('body').trigger('storeloc:mapmarker', gtmData);
				});
		
				// Create a minimum bound based on a set of storeLocations
				bounds.extend(marker.position);
			}
		} else{
			var lable = parseInt(key, 10) + 1;
			let storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
			markerImg.textContent = lable.toString();
			let marker = new google.maps.marker.AdvancedMarkerElement({
				position: storeLocation,
				map: map,
				title: item.name,
				content: markerImg,
				gmpClickable: true
			});
	
			marker.addListener('click', function () {
				infowindow.setOptions({
					content: item.infoWindowHtml
				});
				infowindow.open(map, marker);
				//GTM Push for Selected store
				var gtmData = {};
				gtmData.eventAction = 'Map Interaction';
				gtmData.eventLabel = 'Select Store - ' + item.name;
				$('body').trigger('storeloc:mapmarker', gtmData);
			});
	
			// Create a minimum bound based on a set of storeLocations
			bounds.extend(marker.position);
		}
	});
	// Fit the all the store marks in the center of a minimum bounds when any store has been found.
	if (mapdiv && mapdiv.length !== 0) {
		map.fitBounds(bounds);
	}

	var listener = google.maps.event.addListener(map, 'idle', function() { 
		if ((mapdiv && mapdiv.length == 1) && map.getZoom() > 10) map.setZoom(10); 
		google.maps.event.removeListener(listener); 
	});
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
	var $resultsDiv = $('.results:visible');
	var $mapDiv = $('.map-canvas:visible');
	var hasResults = data.stores.length > 0;

	if (!hasResults) {
		$('.store-locator-no-results').show();
		//GTM For Error Message in case of 0 Stores
		var gtmData = {};
		gtmData.eventAction = 'Message Displayed';
		gtmData.eventLabel = 'We’re sorry, we couldn’t find results for your search';
		$('body').trigger('storeloc:nostoreerror', gtmData);
	} else {
		$('.store-locator-no-results').hide();
	}

	$resultsDiv.empty()
		.data('has-results', hasResults)
		.data('radius', data.radius)
		.data('search-key', data.searchKey);

	$mapDiv.attr('data-locations', data.locations);

	if ($mapDiv.data('has-google-api')) {
		maps();
	} else {
		$('.store-locator-no-apiKey').show();
	}

	if (data.storesResultsHtml) {
		$resultsDiv.append(data.storesResultsHtml);
	}
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
	var $form = element.closest('.store-locator');
	var searchKey = $form.find('[name="postalCode"]').val().trim();
	if(searchKey){
		var radius = $('.results').data('radius');
		var formaction = $form.attr('method');
		var autherisedStore = $('#autherised-retailer').is(':checked');
		var jamesAveryStore = $('#storeModalDialog.show').length > 0 ? true : $('#james-avery-store').is(':checked');
		var url = $form.attr('action');
		var urlParams = { radius: radius, autherisedStore:autherisedStore ,jamesAveryStore:jamesAveryStore};
		var payload = $form.is('form') ? $form.serialize() : { postalCode: searchKey };
		url = appendToUrl(url, urlParams);
		var zipcodeFlag = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(searchKey);
		if(zipcodeFlag){
			getStorelocationAjax(url,formaction,payload,element);
		}else{
			getLatLng(searchKey,url,formaction,payload,element);
		}		
	}
	return false;
}

function getStorelocationAjax(url,action,payload,element){
	var dialog = element.closest('.modal-dialog');
	var spinner = dialog.length ? dialog.spinner() : $.spinner();
	spinner.start();

	$.ajax({
		url: url,
		type: action,
		data: payload,
		dataType: 'json',
		success: function (data) {
			spinner.stop();
			updateStoresResults(data);
			$('#storeModalDialog .find-store-csrf-token').attr('name', data.csrf.tokenName).attr('value', data.csrf.token);
			$('.select-store').prop('disabled', true);
		},error: function(){
			spinner.stop();
		}
	});
}

function getLatLng(searchKey,url,formaction,payload,element){
	var geocoder = new google.maps.Geocoder();
	var dialog = element.closest('.modal-dialog');
	var spinner = dialog.length ? dialog.spinner() : $.spinner();
	spinner.start();
	if(geocoder){
		geocoder.geocode({ 'address': searchKey }, function(results, status) {
			if (status === 'OK') {
				var geocoderResponse = results;
				if(geocoderResponse) {
					var addrLat = geocoderResponse[0].geometry.location.lat();
					var addrLong =  geocoderResponse[0].geometry.location.lng();
					payload = 'lat='+addrLat+'&long='+addrLong+'&'+payload;
					getStorelocationAjax(url,formaction,payload,element);
					spinner.stop();
				}
			}else{
				getStorelocationAjax(url,formaction,payload,element);
			}
		});
	}
	spinner.stop();
}

module.exports = $.extend({}, baseStore, {

	init: function () {
		if ($('.map-canvas').data('has-google-api')) {
			maps();
		}else{
			$('.store-locator-no-apiKey').show();
		}

		if (!$('.results').data('has-results')) {
			$('.store-locator-no-results').show();
		}
	},

	detectLocation: function () {
		// clicking on detect location.
		$('body').on('click', '.detect-location:visible', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			$.spinner().start();
			if (!navigator.geolocation) {
				$.spinner().stop();
				return;
			}

			let data = {
				eventLabel :'Use My Location',
				eventAction : 'Search Filter'
			};
			$('body').trigger('storeloc:usemylocation',data);
			navigator.geolocation.getCurrentPosition(function (position) {
				var $detectLocationButton = $('.detect-location');
				var url = $detectLocationButton.data('action');
				var radius = $('.results:visible').data('radius');
				var urlParams = {
					radius: radius,
					lat: position.coords.latitude,
					long: position.coords.longitude
				};

				url = appendToUrl(url, urlParams);
				$.ajax({
					url: url,
					type: 'get',
					dataType: 'json',
					success: function (data) {
						$.spinner().stop();
						updateStoresResults(data);
						$('.select-store').prop('disabled', true);
					}
				});
			});
		});
	},

	loadMoreResults: function () {

		$('body').on('click', '.btn-load-more', function (e) {
			e.preventDefault();
			var count = 5, totalStoreDisplay;
			var storeList = $('.results.striped .card-body');
			var storeListInvisible = $('.results.striped .card-body.d-none');
			var scrollToFirstResult = storeListInvisible[0];

			for (var i = 0; i < count; i++) {
				if (storeListInvisible[i]) {
					storeListInvisible[i].classList.remove('d-none');
				}
			}
			storeListInvisible = $('.results.striped .card-body.d-none');
			totalStoreDisplay = storeList.length - storeListInvisible.length;
			$('.list-count').html(totalStoreDisplay + ' Out of ');

			if (totalStoreDisplay == storeList.length) {
				$('.btn-load-more').remove();
			}
			$('body').trigger('storeloc:loadmore');
			scrollAnimate($(scrollToFirstResult));
		});
	},

	updateSelectStoreButton: function () {
		$('body').on('click', '.save-store .btn-save-store', (function (event) {
			saveAsMyStore(event);
		}));
	},
	create_storeLocator_custom_dropdowns: function () {
		if ($('.distance-field').length > 0) {
			$('.distance-field select').each(function (i, select) {
				if (!$(this).next().hasClass('storeLocatorDropdown')) {
					$(this).after('<div class="storeLocatorDropdown ' + ($(this).attr('class') || '') + '" tabindex="0"> ' +
						' <span class="current"></span>   ' +
						' <div class="qtyBlock"> <span class="current"></span>' +
						' <div class="list">   <ul></ul>  </div>   </div> </div>');
					var storeLocatorDropdown = $(this).next();
					var options = $(select).find('option');
					var selected = $(this).find('option:selected');
					storeLocatorDropdown.find('.current').html(selected.data('display-text') || selected.text());
					options.each(function (j, o) {
						var display = $(o).data('display-text') || '';
						storeLocatorDropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
					});
				}
			});

			// Event listeners
			$('body').on('click', '.distance-field .storeLocatorDropdown', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				if ($(e.target).hasClass('option selected')) {
					return false;
				}
				$('.distance-field .storeLocatorDropdown').not($(this)).removeClass('open');
				$(this).toggleClass('open');
				if ($(this).hasClass('open')) {
					$(this).find('.option').attr('tabindex', 0);
					$(this).find('.selected').focus();
				}
				else {
					$(this).find('.option').removeAttr('tabindex');
					$(this).focus();
				}
			});

			$('body').on('click', '.storeModalDialog', function (event) {
				event.stopImmediatePropagation();
				if ($(event.target).closest('.storeLocatorDropdown').length === 0) {
					$('.distance-field .storeLocatorDropdown').removeClass('open');
					$('.storeLocatorDropdown .option').removeAttr('tabindex');
				}
			});

			$('body').on('click', '.store-locator-container', function (event) {
				event.stopImmediatePropagation();
				if ($(event.target).closest('.storeLocatorDropdown').length === 0) {
					$('.distance-field .storeLocatorDropdown').removeClass('open');
					$('.storeLocatorDropdown .option').removeAttr('tabindex');
				}
			});

			$('body').on('click', '.distance-field .storeLocatorDropdown .option', function () {
				$(this).closest('.list').find('.selected').removeClass('selected');
				$(this).addClass('selected');

				$('.distance-field .storeLocatorDropdown').removeClass('open');
				$('.storeLocatorDropdown .option').removeAttr('tabindex');

				var text = $(this).data('display-text') || $(this).text();
				//GTM Push for distance dropdown
				var gtmData = {};
				gtmData.eventAction = 'Search Filter';
				gtmData.eventLabel = 'Change Distance - ' + $.trim(text);
				$('body').trigger('storeloc:distanceselect', gtmData);

				$(this).closest('.storeLocatorDropdown').find('.current').text(text);
				$(this).closest('.storeLocatorDropdown').prev('select').val($(this).data('value')).trigger('change');
			});
		}
	},
	search: function () {
		$(document).on('submit', 'form.store-locator', function (e) {
			e.preventDefault();
			e.stopPropagation();
			let searchKey = $(this).find('.zipcode-input') ? $.trim($(this).find('.zipcode-input').val()) : '';
			$(document).trigger('gtm:storelocatorSearch', searchKey);
			search($(this));
		});
		$('.store-locator-container form.store-locator').submit(function (e) {
			e.preventDefault();
			e.stopPropagation();
			let searchKey = $(this).find('.zipcode-input') ? $.trim($(this).find('.zipcode-input').val()) : '';
			$(document).trigger('gtm:storelocatorSearch', searchKey);
			search($(this));
		});
		$('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			search($(this));
		});
	},
	customStoreDetailsOnModal() {
		$('body').on('click', '.modal-dialog .store-detail-link', function (e) {
			e.preventDefault();
			e.stopPropagation();
			let url = $(this).data('url');
			url = url + '&fromStoreModal=true';
			$.spinner().start();
			var storename = $(this).parents('.store-details').find('.store-name').data('store-fullname');
			$('body').trigger('storeloc:storedetails', storename);
			$.ajax({
				url: url,
				type: 'get',
				success: function (data) {
					$('#storeModalDialog').modal('hide');
					setTimeout(() => {
						$.spinner().stop();
						$('#storeDeatilsModal').remove();
						$('.storeModalDetailsWrapper').html('');
						var targetContainer =  $('.storeModalDetailsWrapper');
						if(targetContainer) {
							targetContainer.html(`<div class="modal fade" id="storeDeatilsModal" tabindex="-1" role="dialog" aria-labelledby="storeDetailsModal">
										<div class="modal-dialog" role="document">
											<div class="modal-content">
												<div class="modal-header">
													<h2 class="modal-title">Store Details</h2>
													<button type="button" class="close gtm-store-modal-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
												</div>

												<div class="modal-body">
													${data}
												</div>
											</div>
										</div>
									</div>`);
						}
						$('#storeDeatilsModal .store-details-title').remove();
						$('#storeDeatilsModal').modal('show');
						$('body').trigger('storeloc:afterStoreDetailModalOpen', storename);
					},500);
								
				},
				error: function () {
					$.spinner().stop();
				}
			});
		});
	}
});
